import * as actionTypes from "../../actions/actionTypes";

const initialState = {
  premiumPenalty: [],
  privileges: [],
};

const loadDormitoryQueueApplicationRequest = (state) => {
  return {
    ...state,
    loading: {
      loadDormitoryQueueApplication: true,
    },
  };
};

const loadDormitoryQueueApplicationSuccess = (state, action) => {
  return {
    ...state,
    dormitoryQueueApplications: action.payload,
    loading: {
      ...(state.loading),
      loadDormitoryQueueApplication: false
    },
  };
};

const loadDormitoryQueueApplicationFailure = (state, action) => {
  return {
    ...state,
    loading: {},
    errors: {
      loadDormitoryQueueApplications: action.error,
    },
  };
};

const createDormitoryApplicationRequest = (state) => {
  return {
    ...state,
    loading: {
      createDormitoryApplication: true,
    },
  };
};

const createDormitoryApplicationSuccess = (state, action) => {
  return {
    ...state,
    dormitoryQueueApplications: action.payload,
    loading: {},
  };
};

const createDormitoryApplicationFailure = (state, action) => {
  return {
    ...state,
    loading: {},
    errors: {
      createDormitoryApplication: action.error,
    },
  };
};

const loadPremiumPenaltyRequest = (state) => {
  return {
    ...state,
    loading: {
      loadPremiumPenalty: true,
    },
  };
};

const loadPremiumPenaltySuccess = (state, action) => {
  return {
    ...state,
    premiumPenalty: action.payload,
    loading: {},
  };
};

const loadPremiumPenaltyFailure = (state, action) => {
  return {
    ...state,
    loading: {},
    errors: {
      loadPremiumPenalty: action.error,
    },
  };
};

const loadPrivilegesRequest = (state) => {
  return {
    ...state,
    loading: {
      loadPrivileges: true,
    },
  };
};

const loadPrivilegesSuccess = (state, action) => {
  return {
    ...state,
    privileges: action.payload,
    loading: {},
  };
};

const loadPrivilegesFailure = (state, action) => {
  return {
    ...state,
    loading: {},
    errors: {
      loadPrivileges: action.error,
    },
  };
};

const startDownloadReport = (state) => {
  return {
    ...state,
    loading: {
      loadingApplicationReport: true
    }
  };
};

const stopDownloadReport = (state) => {
  return {
    ...state,
    loading: {
      loadingApplicationReport: false
    }
  };
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.LOAD_DORMITORY_QUEUE_APPLICATION_REQUEST:
      return loadDormitoryQueueApplicationRequest(state);
    case actionTypes.LOAD_DORMITORY_QUEUE_APPLICATION_SUCCESS:
      return loadDormitoryQueueApplicationSuccess(state, action);
    case actionTypes.LOAD_DORMITORY_QUEUE_APPLICATION_FAILURE:
      return loadDormitoryQueueApplicationFailure(state, action);
    case actionTypes.CREATE_DORMITORY_APPLICATION_REQUEST:
      return createDormitoryApplicationRequest(state);
    case actionTypes.CREATE_DORMITORY_APPLICATION_SUCCESS:
      return createDormitoryApplicationSuccess(state, action);
    case actionTypes.CREATE_DORMITORY_APPLICATION_FAILURE:
      return createDormitoryApplicationFailure(state, action);
    case actionTypes.LOAD_PREMIUM_PENALTY_REQUEST:
      return loadPremiumPenaltyRequest(state);
    case actionTypes.LOAD_PREMIUM_PENALTY_SUCCESS:
      return loadPremiumPenaltySuccess(state, action);
    case actionTypes.LOAD_PREMIUM_PENALTY_FAILURE:
      return loadPremiumPenaltyFailure(state, action);
    case actionTypes.LOAD_PRIVILEGES_REQUEST:
      return loadPrivilegesRequest(state);
    case actionTypes.LOAD_PRIVILEGES_SUCCESS:
      return loadPrivilegesSuccess(state, action);
    case actionTypes.LOAD_PRIVILEGES_FAILURE:
      return loadPrivilegesFailure(state, action);
    case actionTypes.LOAD_APPLICATION_REPORT:
      return startDownloadReport(state);
    case actionTypes.SAVE_APPLICATION_REPORT:
      return stopDownloadReport(state);
    default:
      return state;
  }
};

export default reducer;
